$(document).ready(function() 
{
  $(document).on("swell:cart:updated", function()
  {
    var cart = $.ajax({
      type: 'GET', 
      url: '/cart.js',
      dataType: 'json',
      success: function(){
        if(cart.responseJSON.item_count>0){
          var isPricedItem = 0;
          cart.responseJSON.items.forEach(function(item)
          {
            if(item.final_price > 0)
            {
              if(item.properties["_swell_discount_type"] === undefined)
              {
                isPricedItem = 1;
                return false;
              }
            }
          });
          if(isPricedItem == 0)
          {
            window.location.href = "/cart/clear";
          }
        }
      }
    });
  });
});
